import React from 'react';
import { useSelector } from 'react-redux';
import classes from './FinalProjectAnnouncementBanner.module.css';

const FinalProjectAnnouncementBanner = () => {

    const { texts } = useSelector(state => state.translate);
    const {general} = useSelector(state => state.uiData);

    return (
        <div className={classes.AnnouncementBanner}>
            <p className={classes.AnnouncementTitle}>📣 {texts.faceToFaceExamAnnouncementTitle}</p>
            <p className={classes.AnnouncementBody}>{texts.faceToFaceExamAnnouncementBody}</p>
            <p className={classes.AnnouncementLink}>
                <a href={general?.FinalProject?.matriculationLinkForFaceToFaceExam} target="_blank" rel="noopener noreferrer">
                    <span className={classes.AnnouncementLinkText}>{texts.faceToFaceExamAnnouncementLinkText}</span>
                </a>
            </p>
            <p className={classes.AnnouncementFooter}>{texts.faceToFaceExamAnnouncementFooter}</p>
        </div>
    );
};

export default FinalProjectAnnouncementBanner;
